export const ProfileItems = [
  {
    title: "Account",
    path: "/account",
  },
  {
    title: "Orders",
    path: "/account/orders",
  },
];

export const LanguageItems = [
  {
    title: "Hindi",
    path: "/hindi",
  },
  {
    title: "English",
    path: "/english",
  },
];
